import {t} from "@lingui/core/macro";
import * as React from "react";

/**
 * Renders a left pointing "back" icon (typically in top left of headers).
 */
export default class BackIcon extends React.Component<any> {
    node: React.ElementRef<"g"> | null | undefined;

    componentDidMount() {
        // HACK(kevinb): remove when we upgrade to React 15
        this.node?.setAttribute("stroke-linejoin", "round");
    }

    render(): React.ReactNode {
        const title = t`Back`;
        return (
            <svg width="24" height="24">
                <g
                    ref={(node) => (this.node = node)}
                    id="source"
                    fill="none"
                    transform="translate(5, 5)"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                >
                    <title>{title}</title>
                    <path d="M1,7 L14,7" />
                    <polyline points="7 0 0 7 7 14" />
                </g>
            </svg>
        );
    }
}
